import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

// DELETE /api/admin/news/:id
const DeleteNewsModal = ({ isOpen, news, onClose, onConfirm }) => {
  if (!isOpen || !news) return null;

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete News</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
          Are you sure you want to permanently delete{" "}
          <strong>{news.title || "this article"}</strong>? This action cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={() => onConfirm(news)}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteNewsModal;
